export default function buildOwnerViewerPresentationViewer(
    actionTypes,
    updateChangeModel,
    updateCreateModel,
    canSave
) {
    const {
        SELECT_PERMISSION_HOLDER_TYPE,
        SEARCH_ADD_OWNERS_VIEWERS,
        SEARCH_ADD_OWNERS_VIEWERS_RESPONSE,
        SELECT_ADD_OWNER_VIEWER,
        APPLY_ADD_OWNERS_VIEWERS,
        CANCEL_ADD_OWNERS_VIEWERS
    } = actionTypes
    return (state, action) => {
        const {
            type,
            selectedPermissionHolder,
            ownerViewer: ownerViewerId
        } = action
        switch (type) {
            case SELECT_PERMISSION_HOLDER_TYPE:
                return {
                    ...state,
                    selectedPermissionHolder
                }
            case SEARCH_ADD_OWNERS_VIEWERS:
                return {
                    ...state,
                    isFetchingOwnersViewersSearch: true,
                    isAddingOwnersViewers: true
                }
            case SEARCH_ADD_OWNERS_VIEWERS_RESPONSE:
                return {
                    ...state,
                    isFetchingOwnersViewersSearch: false,
                    ownersViewersSearchResponse: action.data
                }
            case SELECT_ADD_OWNER_VIEWER: {
                const ownerViewerKey = `${state.selectedPermissionHolder}ToAdd`
                const ownerViewer = state.ownersViewersSearchResponse.filter(
                    ({ id }) => id === ownerViewerId
                )[0]
                const ownersViewersToAdd = [
                    ...state[ownerViewerKey],
                    ownerViewer
                ]
                return {
                    ...state,
                    [ownerViewerKey]: ownersViewersToAdd
                }
            }
            case APPLY_ADD_OWNERS_VIEWERS: {
                const { workingModel, updateModel } = state
                let newWorkingModel = workingModel
                let newUpdateModel = updateModel
                const toProcess = ["owners", "viewers"]
                toProcess.forEach(ownerViewerType => {
                    const toAdd = state[`${ownerViewerType}ToAdd`].map(
                        addIsAdded
                    )
                    if (toAdd.length > 0) {
                        const updateModelFunction = state.isCreateMode
                            ? updateCreateModel
                            : updateChangeModel
                        newWorkingModel = newWorkingModel.set(
                            ownerViewerType,
                            workingModel[ownerViewerType].concat(toAdd)
                        )
                        newUpdateModel = updateModelFunction(
                            ownerViewerType,
                            newWorkingModel[ownerViewerType],
                            updateModel,
                            workingModel
                        )
                    }
                })
                return {
                    ...state,
                    workingModel: newWorkingModel,
                    updateModel: newUpdateModel,
                    isAddingOwnersViewers: false,
                    ownersToAdd: [],
                    viewersToAdd: [],
                    ownersViewersSearchResponse: [],
                    canSave: canSave(
                        newUpdateModel,
                        state.imageToUpload,
                        newWorkingModel
                    )
                }
            }
            case CANCEL_ADD_OWNERS_VIEWERS:
                return {
                    ...state,
                    isAddingOwnersViewers: false,
                    ownersToAdd: [],
                    viewersToAdd: [],
                    ownersViewersSearchResponse: []
                }
            default:
                return state
        }
    }
}

function addIsAdded(ownerViewer) {
    return {
        ...ownerViewer,
        isAdded: true,
        can_remove: true
    }
}
